import { render, staticRenderFns } from "./MhlvCaseDetails.vue?vue&type=template&id=62ef1090"
import script from "./MhlvCaseDetails.vue?vue&type=script&lang=js"
export * from "./MhlvCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports